<section class="bn-options-section" aria-labelledby="care-plan-options-heading">
  <header
    class="bn-options-section__header flex items-center justify-between gap-3"
  >
    <h3 id="care-plan-options-heading" class="bn-options-section__title m-0">
      <i class="pi pi-sparkles" aria-hidden="true"></i>
      Options <span>({{ store.count() }})</span>
    </h3>
    @if (!readonly()) {
      <button type="button" class="bn-options-section__add" (click)="openAdd()">
        + Add
      </button>
    }
  </header>

  @if (store.loading()) {
    <div class="flex flex-col gap-3" role="status" aria-label="Loading options">
      <p-skeleton height="6.25rem" borderRadius="0.75rem" />
      <p-skeleton height="6.25rem" borderRadius="0.75rem" />
    </div>
  } @else if (store.error(); as error) {
    <div class="bn-options-section__message" role="alert">
      <p class="m-0">{{ error }}</p>
      <button type="button" (click)="store.retry()">Retry</button>
    </div>
  } @else if (store.options().length === 0) {
    <div class="bn-options-section__message">
      <p class="m-0">No options yet.</p>
      @if (!readonly()) {
        <button type="button" (click)="openAdd()">+ Add an option</button>
      }
    </div>
  } @else {
    <bn-care-plan-card-list ariaLabel="Options for this case">
      @for (option of store.options(); track option.id) {
        <bn-option-card
          [option]="option"
          [store]="store"
          [readonly]="readonly()"
        />
      }
    </bn-care-plan-card-list>
  }
</section>
